<template>
  <Section
    v-bind="$attrs"
    title="Statuses"
    :shouldShowSearch="shouldShowSearch"
    :toolbarActions="toolbarActions"
    @onClicked="(val) => $emit(val)"
    icon="info"
    :isLoading="isLoading"
    @onShouldSearch="(val) => (searchText = val)"
  >
    <v-data-table
      :headers="headers"
      :items="assetStatusList"
      :search="searchText"
      item-key="id"
      class="elevation-1"
      :rows-per-page-items="[15, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">
          <v-chip
            v-for="activityTypeId in props.item.activityTypeIds"
            :key="activityTypeId"
            :disabled="isLoading"
          >
            {{
              "" +
              _entityPropertyValueByName({
                entityList: activityTypeList,
                idKey: "id",
                idValue: activityTypeId,
                propertyKey: "name",
              })
            }}
          </v-chip>
        </td>
        <td class="text-xs-left">
          <v-icon :color="!props.item.isIdle ? 'green' : 'red'">{{
            !props.item.isIdle ? "done" : "close"
          }}</v-icon>
        </td>
        <td class="text-xs-left">
          <v-icon :color="props.item.isEnabled ? 'green' : 'red'">{{
            props.item.isEnabled ? "done" : "close"
          }}</v-icon>
        </td>
        <td class="text-xs-right">
          <ControlButton
            text="Edit"
            icon="edit"
            iconColor="warning"
            :disabled="isLoading"
            @onClicked="
              $emit('onEditAssetStatusClicked', {
                assetStatusToEdit: props.item,
              })
            "
          />
        </td>
      </template>
    </v-data-table>
  </Section>
</template>

<script>
import Section from '../../../../common/components/layouts/Section'
import ControlButton from '../../../../common/components/controls/ControlButton'
import mixinAssetHelper from '../../../../common/mixins/mixinAssetHelper'

export default {
  inheritAttrs: false,
  components: {
    Section,
    ControlButton,
  },
  mixins: [mixinAssetHelper],
  props: {
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
    shouldShowSearch: {
      type: Boolean,
    },
    assetStatusList: {
      type: Array,
      required: true,
    },
    activityTypeList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    searchText: null,
    headers: [
      { text: 'Name', value: 'name', align: 'left', sortable: false },
      {
        text: 'Activity Types',
        value: 'activityTypeId',
        align: 'left',
        sortable: false,
      },
      { text: 'In Use', value: 'isIdle', align: 'left', sortable: false },
      { text: 'Enabled', value: 'isEnabled', align: 'left', sortable: false },
      { text: '', sortable: false },
    ],
  }),
  computed: {},
  methods: {},
}
</script>
